import { AfterContentChecked, ChangeDetectorRef, Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';

import { BooleanStrings } from '../../../../constants';
import { MenuService } from '../../../../services';
import { BaseRendererComponent } from '../base-renderer/base-renderer.component';

@Component({
  selector: 'app-checkbox-renderer',
  templateUrl: './checkbox-renderer.component.html',
  styleUrl: './checkbox-renderer.component.scss',
})
export class CheckboxRendererComponent
  extends BaseRendererComponent
  implements AfterContentChecked, ICellRendererAngularComp
{
  protected readonly BooleanStrings = BooleanStrings;

  constructor(
    public menuService: MenuService,
    private cdRef: ChangeDetectorRef,
  ) {
    super();
  }

  ngAfterContentChecked() {
    this.cdRef.detectChanges();
  }

  get isEditable(): boolean {
    return (this.params.colDef as any)?.editable(this.params as any) ?? false;
  }

  public onChange(event: any) {
    let checked = event.target.checked;
    let colId = this.params.column.getColId();
    this.params.node.setDataValue(colId, checked);
    if (event.currentTarget.checked) {
      this.params.node.setSelected(true);
    }
  }
}
